var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InfoAlert',{attrs:{"showDismissibleAlert":_vm.showDismissibleAlert,"info":_vm.info},on:{"close":function($event){_vm.showDismissibleAlert = false}}})
}
var staticRenderFns = []

export { render, staticRenderFns }